
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AddressFields": [
      "Address",
      "AddressAndFieldUpdates"
    ],
    "BankAccount": [
      "ClientBankAccount",
      "OrganisationBankAccount"
    ],
    "CancellationReasonColumns": [
      "CancellationReasonReport"
    ],
    "CaseReportsColumns": [
      "CurrentPipelineReport"
    ],
    "FMAFields": [
      "DipApplicationError",
      "FMAFieldsResponse"
    ],
    "FMAResponse": [
      "ApplicationResponse",
      "DipApplicationError"
    ],
    "LedgerBase": [
      "Ledger",
      "OneOffLedger",
      "RecurringLedger"
    ],
    "LedgerPaymentSourceDetail": [
      "ClientVersion",
      "Organisation",
      "User"
    ],
    "QuestionI": [
      "ClientVulnerabilityQuestion",
      "SurveyQuestion"
    ],
    "SubmitDipWithApplicationDetails": [
      "ApplicationDetails",
      "SubmitDip"
    ],
    "VersionedObject": [
      "CaseVersion",
      "ClientVersion",
      "PropertyVersion"
    ]
  }
};
      export default result;
    